import React, { Component } from "react";
import { Link } from "react-router-dom";

// Layout
import Header from "../layout/header/header1";

// Images
import bannerImg from "../../images/banner/banner3.jpg";
import news81Img from "../../images/news/news8_1.jpg";
import news82Img from "../../images/news/news8_2.jpg";

import { withTranslation } from "react-i18next";


class news8 extends Component {
	componentDidMount() {

	}

	componentWillMount() {
		const { t } = this.props;
		document.getElementById('title').innerText = t("News8_Title");
	}

	componentWillUnmount() {
		const { t } = this.props;
		document.getElementById('title').innerText = t("Home_Title");
	}

	render() {
		const { t } = this.props;
		return (
			<>
				<Header />

				<div className="page-content">
					<div
						className="page-banner ovbl-dark"
						style={{ backgroundImage: "url(" + bannerImg + ")" }}
					>
						<div className="container">
							<div className="page-banner-entry">
								<h1 className="text-white">{t("News8_Title")}</h1>
							</div>
						</div>
					</div>
					<div className="breadcrumb-row">
						<div className="container">
							<ul className="list-inline">
								<li>
									<Link to="/">{t("News8_LinkHome")}</Link>
								</li>
								<li>{t("News8_LinkCourses")}</li>
							</ul>
						</div>
					</div>
					<div className="content-block">
						<div className="section-area section-sp1">
							<div className="container">
								<div className="row d-flex flex-row-reverse">
									<div className="col-xl-9 col-lg-8 col-md-12 col-sm-12">
										<div className="courses-post">
											<h1>{t("News8_Content_H")}</h1>
											<p>{t("News8_Content_P1")}</p>
											<p>{t("News8_Content_P2")}</p>
											<img alt="" src={news81Img} />
											<p>{t("News8_Content_P3")}</p>
											<strong>{t("News8_Content_P4")}</strong>
											<p>{t("News8_Content_P5")}</p>
											<p>{t("News8_Content_P6")}</p>
											<strong>{t("News8_Content_P7")}</strong>
											<p>{t("News8_Content_P8")}</p>
											<img alt="" src={news82Img} />
											<p>{t("News8_Content_P9")}</p>
											<strong>{t("News8_Content_P10")}</strong>
											<p>{t("News8_Content_P11")}</p>
											<strong>{t("News8_Content_P12")}</strong>
											<p>{t("News8_Content_P13")}</p>
										</div>

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}
}

export default news8 = withTranslation()(news8);
